var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _path, _symbol19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu",
    viewBox: "0 0 30 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 1.882,
    d: "M3.765 9.726h22.588M3.765 16h22.588M3.765 22.274h22.588"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-right",
    viewBox: "0 0 31 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#97d28b",
    d: "M15.515.485C24.084.485 31.03 7.431 31.03 16s-6.946 15.515-15.515 15.515S0 24.569 0 16 6.946.485 15.515.485z",
    style: {
      fill: "var(--color1, #97d28b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#173d33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.97,
    d: "M17.086 12.076 21.01 16l-3.924 3.924M10.02 16H20.9",
    style: {
      stroke: "var(--color2, #173d33)"
    }
  })), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-mail",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M22.667 27.333H9.334c-4 0-6.667-2-6.667-6.667v-9.333c0-4.667 2.667-6.667 6.667-6.667h13.333c4 0 6.667 2 6.667 6.667v9.333c0 4.667-2.667 6.667-6.667 6.667z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m22.667 12-4.173 3.333c-1.373 1.093-3.627 1.093-5 0L9.334 12"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-left",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.333,
    d: "m12.76 7.905-8.093 8.093 8.093 8.093M27.332 15.999H4.892"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-instagram",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M12 29.333h8c6.667 0 9.333-2.667 9.333-9.333v-8c0-6.667-2.667-9.333-9.333-9.333h-8c-6.667 0-9.333 2.667-9.333 9.333v8c0 6.667 2.667 9.333 9.333 9.333z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M16 20.667a4.667 4.667 0 1 0 0-9.334 4.667 4.667 0 0 0 0 9.334z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2.667,
    d: "M23.515 9.333h.015"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-facebook",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M18.667 12.4v3.867h3.467c.267 0 .4.267.4.533l-.533 2.533c0 .133-.267.267-.4.267h-2.933v9.733h-4v-9.6h-2.267c-.267 0-.4-.133-.4-.4V16.8c0-.267.133-.4.4-.4h2.267V12c0-2.267 1.733-4 4-4h3.6c.267 0 .4.133.4.4v3.2c0 .267-.133.4-.4.4h-3.2c-.267 0-.4.133-.4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M20 29.333h-8c-6.667 0-9.333-2.667-9.333-9.333v-8c0-6.667 2.667-9.333 9.333-9.333h8c6.667 0 9.333 2.667 9.333 9.333v8c0 6.667-2.667 9.333-9.333 9.333z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-rightup",
    viewBox: "0 0 30 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.882,
    d: "M11.829 8.456h10.772v10.772M7.517 23.541 22.451 8.607"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2.4,
    d: "m9.334 9.333 13.333 13.333m-13.333.001L22.667 9.334"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-fav",
    viewBox: "0 0 55 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#173d33",
    style: {
      fill: "var(--color2, #173d33)"
    },
    d: "M37.829 22.771c-.115-.273-9.56-18.774-9.715-19.029-.326-.772-.81-1.47-1.421-2.049S25.356.665 24.562.376a6.236 6.236 0 0 0-4.913.28 6.154 6.154 0 0 0-1.964 1.55c-.54.645-.939 1.392-1.174 2.197s-.299 1.647-.188 2.477c.11.83.392 1.628.828 2.345.115.273 9.155 17.981 9.31 18.236.115.274.251.539.405.793.326.772.81 1.47 1.421 2.049s1.336 1.028 2.131 1.317a6.24 6.24 0 0 0 4.913-.28 6.154 6.154 0 0 0 1.964-1.55c.54-.645.939-1.393 1.174-2.197s.299-1.647.188-2.477a6.04 6.04 0 0 0-.828-2.345z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97d28b",
    style: {
      fill: "var(--color3, #97d28b)"
    },
    d: "M26.921 10.252a6.04 6.04 0 0 0 .975-6.97c-.39-.742-.93-1.397-1.588-1.924S24.89.444 24.075.221c-.816-.223-1.669-.278-2.507-.161s-1.642.404-2.363.842a6.118 6.118 0 0 0-1.826 1.705c-.203.214-15.54 18.897-15.71 19.139-.579.61-1.025 1.331-1.309 2.119a6.022 6.022 0 0 0 .334 4.851 6.092 6.092 0 0 0 1.588 1.924c.657.527 1.418.914 2.233 1.137s1.669.278 2.507.161 1.642-.404 2.363-.842a6.13 6.13 0 0 0 1.826-1.705c.203-.214 15.54-18.897 15.71-19.138zM53.312 10.252c.579-.61 1.025-1.331 1.309-2.119a6.022 6.022 0 0 0-.335-4.851c-.39-.742-.93-1.397-1.588-1.924S51.28.444 50.465.221c-.816-.223-1.669-.278-2.507-.161s-1.642.404-2.363.842a6.118 6.118 0 0 0-1.826 1.705c-.203.214-15.54 18.897-15.71 19.139a6.04 6.04 0 0 0-.975 6.97c.39.742.931 1.397 1.588 1.924.657.527 1.418.914 2.233 1.137s1.669.278 2.507.161 1.642-.404 2.363-.842a6.118 6.118 0 0 0 1.826-1.705c.203-.214 15.54-18.897 15.71-19.139z"
  })), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ranking",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M11.56 18.667H5.333a2.675 2.675 0 0 0-2.667 2.667v8h8.893V18.667z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M17.774 13.333h-3.56A2.675 2.675 0 0 0 11.547 16v13.333h8.893V16a2.666 2.666 0 0 0-2.667-2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M26.667 22.667H20.44v6.667h8.893v-4c0-1.467-1.2-2.667-2.667-2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m16.693 2.76.707 1.413c.093.2.347.387.56.413l1.28.213c.813.133 1.013.733.427 1.307l-1 1c-.173.173-.267.493-.213.72l.28 1.227c.227.973-.293 1.347-1.147.84l-1.2-.707a.826.826 0 0 0-.787 0l-1.2.707c-.853.507-1.373.133-1.147-.84l.28-1.227c.053-.227-.04-.56-.213-.72l-.987-.987c-.587-.587-.4-1.173.427-1.307l1.28-.213a.89.89 0 0 0 .56-.413l.707-1.413c.387-.773 1-.773 1.387-.013z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-cpu-charge",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12.8 26.667h6.4c5.333 0 7.467-2.133 7.467-7.467v-6.4c0-5.333-2.133-7.467-7.467-7.467h-6.4c-5.333 0-7.467 2.133-7.467 7.467v6.4c0 5.333 2.133 7.467 7.467 7.467z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14 22.667h4c3.333 0 4.667-1.333 4.667-4.667v-4c0-3.333-1.333-4.667-4.667-4.667h-4c-3.333 0-4.667 1.333-4.667 4.667v4c0 3.333 1.333 4.667 4.667 4.667zM10.68 5.333V2.666M16 5.333V2.666M21.333 5.333V2.666M26.667 10.667h2.667M26.667 16h2.667M26.667 21.333h2.667M21.333 26.667v2.667M16.013 26.667v2.667M10.68 26.667v2.667M2.667 10.667h2.667M2.667 16h2.667M2.667 21.333h2.667"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m16 12.933-1.253 2.187c-.28.48-.053.88.507.88h1.493c.56 0 .787.4.507.88l-1.253 2.187"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-global-edit",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M29.333 16C29.333 8.64 23.36 2.667 16 2.667S2.667 8.64 2.667 16 8.64 29.333 16 29.333"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.666 4h1.333a37.898 37.898 0 0 0 0 24h-1.333M20 4a38.083 38.083 0 0 1 1.947 12"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 21.333V20a38.083 38.083 0 0 0 12 1.947M4 12a37.898 37.898 0 0 1 24 0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m25.614 20.987-4.72 4.72a1.64 1.64 0 0 0-.4.787l-.253 1.8c-.093.653.36 1.107 1.013 1.013l1.8-.253c.253-.04.613-.213.787-.4l4.72-4.72c.813-.813 1.2-1.76 0-2.96-1.187-1.187-2.133-.8-2.947.013z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M24.934 21.667c.4 1.44 1.52 2.56 2.96 2.96"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-maximize-circle",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M22.667 4H28v5.333M20 12l8-8M9.333 28H4v-5.333M12 20l-8 8M18.693 2.933A13.794 13.794 0 0 0 16 2.666c-7.36 0-13.333 5.973-13.333 13.333 0 .92.093 1.813.267 2.667M13.307 29.067c.867.173 1.773.267 2.693.267 7.36 0 13.333-5.973 13.333-13.333 0-.907-.093-1.8-.267-2.667"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-up-right",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8,
    d: "M14.399 12.26h5.341v5.341M12.261 19.739l7.405-7.405"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-next",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.485,
    d: "M16 .242C24.703.242 31.758 7.297 31.758 16S24.703 31.758 16 31.758.242 24.703.242 16 7.297.242 16 .242z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.727,
    d: "M17.768 11.585 22.183 16l-4.415 4.415M9.819 15.999h12.24"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-prev",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.485,
    d: "M16 .242C7.297.242.242 7.297.242 16S7.297 31.758 16 31.758 31.758 24.703 31.758 16 24.703.242 16 .242z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.727,
    d: "M14.232 11.585 9.817 16l4.415 4.415M22.181 15.999H9.941"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-add",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#97d28b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M8 16h16M16 24V8",
    style: {
      stroke: "var(--color1, #97d28b)"
    }
  })), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-minus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#173d33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M8 16h16"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-map",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3.053 10.373v12.973c0 2.533 1.8 3.573 3.987 2.32l3.133-1.787c.68-.387 1.813-.427 2.52-.067l7 3.507c.707.347 1.84.32 2.52-.067l5.773-3.307c.733-.427 1.347-1.467 1.347-2.32V8.652c0-2.533-1.8-3.573-3.987-2.32l-3.133 1.787c-.68.387-1.813.427-2.52.067l-7-3.493c-.707-.347-1.84-.32-2.52.067L4.4 8.067c-.747.427-1.347 1.467-1.347 2.307zM11.413 5.333v17.333M20.973 8.826v17.84"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-call",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M29.293 24.44c0 .48-.107.973-.333 1.453s-.52.933-.907 1.36c-.653.72-1.373 1.24-2.187 1.573-.8.333-1.667.507-2.6.507-1.36 0-2.813-.32-4.347-.973s-3.067-1.533-4.587-2.64a38.332 38.332 0 0 1-4.373-3.733 37.98 37.98 0 0 1-3.72-4.36c-1.093-1.52-1.973-3.04-2.613-4.547-.64-1.52-.96-2.973-.96-4.36 0-.907.16-1.773.48-2.573.32-.813.827-1.56 1.533-2.227.853-.84 1.787-1.253 2.773-1.253.373 0 .747.08 1.08.24.347.16.653.4.893.747l3.093 4.36c.24.333.413.64.533.933.12.28.187.56.187.813 0 .32-.093.64-.28.947a4.52 4.52 0 0 1-.747.947l-1.013 1.053a.712.712 0 0 0-.213.533c0 .107.013.2.04.307.04.107.08.187.107.267.24.44.653 1.013 1.24 1.707.6.693 1.24 1.4 1.933 2.107.72.707 1.413 1.36 2.12 1.96.693.587 1.267.987 1.72 1.227.067.027.147.067.24.107a.92.92 0 0 0 .333.053c.227 0 .4-.08.547-.227l1.013-1c.333-.333.653-.587.96-.747.307-.187.613-.28.947-.28.253 0 .52.053.813.173s.6.293.933.52l4.413 3.133c.347.24.587.52.733.853.133.333.213.667.213 1.04z"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-menu",
    viewBox: "0 0 30 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.882,
    d: "M11.829 8.456h10.772v10.772M7.517 23.541 22.451 8.607"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logo",
    viewBox: "0 0 215 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#97d28b",
    style: {
      fill: "var(--color1, #97d28b)"
    },
    d: "M170.352 17.712c-0.874 0-1.538-0.275-1.992-0.824s-0.68-1.264-0.68-2.144c0-0.405 0.050-0.781 0.152-1.128 0.106-0.352 0.262-0.667 0.464-0.944 0.208-0.283 0.486-0.504 0.832-0.664s0.744-0.24 1.192-0.24c0.614 0 1.114 0.144 1.504 0.432 0.39 0.283 0.656 0.693 0.8 1.232l-0.728 0.152c-0.24-0.763-0.762-1.144-1.568-1.144-0.602 0-1.072 0.205-1.408 0.616s-0.504 0.981-0.504 1.712c0 0.736 0.17 1.304 0.512 1.704 0.342 0.395 0.822 0.592 1.44 0.592 0.518 0 0.92-0.128 1.208-0.384 0.294-0.256 0.44-0.565 0.44-0.928v-0.6h-1.592v-0.608h2.288v1.088c0 0.592-0.206 1.088-0.616 1.488-0.41 0.395-0.992 0.592-1.744 0.592zM173.751 17.6v-5.712h2.096c0.603 0 1.075 0.147 1.416 0.44 0.342 0.288 0.512 0.691 0.512 1.208 0 0.416-0.114 0.763-0.344 1.040-0.229 0.272-0.554 0.451-0.976 0.536l1.392 2.488h-0.848l-1.264-2.384h-1.248v2.384h-0.736zM174.487 14.552h1.336c0.379 0 0.672-0.085 0.88-0.256 0.214-0.171 0.32-0.408 0.32-0.712 0-0.699-0.405-1.048-1.216-1.048h-1.32v2.016zM178.814 17.6v-5.712h3.856v0.648h-3.12v1.848h2.584v0.648h-2.584v1.92h3.128v0.648h-3.864zM183.65 17.6v-5.712h3.856v0.648h-3.12v1.848h2.584v0.648h-2.584v1.92h3.128v0.648h-3.864zM188.486 17.6v-5.712h0.888l2.624 3.912 0.432 0.688h0.080l-0.008-1.096v-3.504h0.712v5.712h-0.848l-2.536-3.752-0.552-0.848h-0.072l0.008 1.088v3.512h-0.728z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#173d33",
    style: {
      fill: "var(--color2, #173d33)"
    },
    d: "M194.597 17.6v-5.712h3.856v0.648h-3.12v1.848h2.584v0.648h-2.584v1.92h3.128v0.648h-3.864zM199.433 17.6v-5.712h2.096c0.602 0 1.074 0.147 1.416 0.44 0.342 0.288 0.512 0.691 0.512 1.208 0 0.416-0.114 0.763-0.344 1.040-0.23 0.272-0.554 0.451-0.976 0.536l1.392 2.488h-0.848l-1.264-2.384h-1.248v2.384h-0.736zM200.169 14.552h1.336c0.378 0 0.672-0.085 0.88-0.256 0.214-0.171 0.32-0.408 0.32-0.712 0-0.699-0.406-1.048-1.216-1.048h-1.32v2.016zM206.799 17.712c-0.874 0-1.538-0.275-1.992-0.824s-0.68-1.264-0.68-2.144c0-0.405 0.051-0.781 0.152-1.128 0.107-0.352 0.262-0.667 0.464-0.944 0.208-0.283 0.486-0.504 0.832-0.664s0.744-0.24 1.192-0.24c0.614 0 1.115 0.144 1.504 0.432 0.39 0.283 0.656 0.693 0.8 1.232l-0.728 0.152c-0.24-0.763-0.762-1.144-1.568-1.144-0.602 0-1.072 0.205-1.408 0.616s-0.504 0.981-0.504 1.712c0 0.736 0.171 1.304 0.512 1.704 0.342 0.395 0.822 0.592 1.44 0.592 0.518 0 0.92-0.128 1.208-0.384 0.294-0.256 0.44-0.565 0.44-0.928v-0.6h-1.592v-0.608h2.288v1.088c0 0.592-0.205 1.088-0.616 1.488-0.41 0.395-0.992 0.592-1.744 0.592zM211.506 17.6v-2.024l-2.056-3.688h0.856l1.56 2.968 1.568-2.968h0.848l-2.040 3.688v2.024h-0.736zM168.048 24.8v-5.712h3.744v0.648h-3.008v1.984h2.496v0.656h-2.496v2.424h-0.736zM174.845 24.912c-0.848 0-1.512-0.285-1.992-0.856-0.474-0.571-0.712-1.277-0.712-2.12s0.243-1.547 0.728-2.112c0.491-0.571 1.15-0.856 1.976-0.856s1.486 0.285 1.976 0.856c0.491 0.571 0.736 1.275 0.736 2.112 0 0.843-0.24 1.549-0.72 2.12-0.474 0.571-1.138 0.856-1.992 0.856zM174.845 24.256c0.598 0 1.072-0.211 1.424-0.632 0.358-0.421 0.536-0.984 0.536-1.688 0-0.699-0.178-1.259-0.536-1.68-0.357-0.432-0.832-0.648-1.424-0.648-0.581 0-1.053 0.216-1.416 0.648-0.357 0.421-0.536 0.981-0.536 1.68 0 0.704 0.176 1.267 0.528 1.688 0.358 0.421 0.832 0.632 1.424 0.632zM178.549 24.8v-5.712h2.096c0.602 0 1.074 0.147 1.416 0.44 0.341 0.288 0.512 0.691 0.512 1.208 0 0.416-0.115 0.763-0.344 1.040-0.23 0.272-0.555 0.451-0.976 0.536l1.392 2.488h-0.848l-1.264-2.384h-1.248v2.384h-0.736zM179.285 21.752h1.336c0.378 0 0.672-0.085 0.88-0.256 0.213-0.171 0.32-0.408 0.32-0.712 0-0.699-0.406-1.048-1.216-1.048h-1.32v2.016zM185.448 24.8v-5.712h0.736v5.056h3v0.656h-3.736zM189.94 24.8v-5.712h0.736v5.712h-0.736zM192.058 24.8v-5.712h3.744v0.648h-3.008v1.984h2.496v0.656h-2.496v2.424h-0.736zM196.613 24.8v-5.712h3.856v0.648h-3.12v1.848h2.584v0.648h-2.584v1.92h3.128v0.648h-3.864z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.788 25.143c-4.118 0-7.022-2.904-7.022-6.864s2.904-6.864 7.022-6.864c4.118 0 6.97 2.904 6.97 6.864v1.030h-10.982c0.396 2.086 1.98 3.221 4.013 3.221 1.531 0 2.64-0.449 3.353-1.426h3.089c-1.003 2.455-3.379 4.039-6.442 4.039zM31.854 16.906h7.894c-0.502-1.901-2.059-2.878-3.96-2.878-1.954 0-3.432 1.003-3.934 2.878zM50.252 25.143c-4.118 0-7.022-2.904-7.022-6.864s2.904-6.864 7.022-6.864c3.511 0 6.098 2.112 6.758 5.148h-2.878c-0.607-1.505-2.006-2.508-3.881-2.508-2.482 0-4.145 1.769-4.145 4.224s1.663 4.224 4.145 4.224c1.874 0 3.274-1.003 3.881-2.508h2.878c-0.66 3.036-3.247 5.148-6.758 5.148zM64.51 25.143c-4.118 0-7.022-2.904-7.022-6.864s2.904-6.864 7.022-6.864c4.118 0 7.022 2.904 7.022 6.864s-2.904 6.864-7.022 6.864zM64.51 22.503c2.482 0 4.118-1.769 4.118-4.224s-1.637-4.224-4.118-4.224c-2.482 0-4.145 1.769-4.145 4.224s1.663 4.224 4.145 4.224zM77.495 25.143c-3.3 0-5.386-1.769-5.465-4.171h2.878c0.053 0.977 0.924 1.637 2.587 1.637 1.742 0 2.561-0.739 2.561-1.637 0-1.109-1.241-1.241-2.772-1.452-2.112-0.264-4.99-0.66-4.99-3.749 0-2.614 2.033-4.356 5.174-4.356s5.095 1.795 5.148 4.066h-2.825c-0.079-0.898-0.898-1.531-2.297-1.531-1.505 0-2.323 0.713-2.323 1.61 0 1.109 1.294 1.241 2.772 1.452 2.006 0.264 4.99 0.634 4.99 3.749 0 2.64-2.138 4.382-5.439 4.382zM90.474 25.143c-4.118 0-7.022-2.904-7.022-6.864s2.904-6.864 7.022-6.864c4.118 0 7.022 2.904 7.022 6.864s-2.904 6.864-7.022 6.864zM90.474 22.503c2.482 0 4.118-1.769 4.118-4.224s-1.637-4.224-4.118-4.224c-2.482 0-4.145 1.769-4.145 4.224s1.663 4.224 4.145 4.224zM98.945 24.8v-18.744h2.851v18.744h-2.851zM110.25 25.143c-3.854 0-6.442-2.218-6.442-6.6v-6.785h2.851v6.785c0 2.64 1.426 3.96 3.59 3.96s3.59-1.32 3.59-3.96v-6.785h2.851v6.785c0 4.356-2.587 6.6-6.442 6.6zM123.5 25.143c-3.142 0-5.28-1.742-5.28-5.333v-12.672h2.851v4.62h6.943v2.587h-6.943v5.465c0 1.901 0.977 2.693 2.429 2.693s2.455-0.766 2.455-2.693v-0.317h2.825v0.317c0 3.59-2.138 5.333-5.28 5.333zM131.672 9.91c-1.109 0-1.927-0.845-1.927-1.954s0.818-1.954 1.927-1.954c1.109 0 1.927 0.845 1.927 1.954s-0.818 1.954-1.927 1.954zM130.22 24.8v-13.042h2.851v13.042h-2.851zM141.552 25.143c-4.118 0-7.022-2.904-7.022-6.864s2.904-6.864 7.022-6.864c4.118 0 7.022 2.904 7.022 6.864s-2.904 6.864-7.022 6.864zM141.552 22.503c2.482 0 4.118-1.769 4.118-4.224s-1.637-4.224-4.118-4.224c-2.482 0-4.145 1.769-4.145 4.224s1.663 4.224 4.145 4.224zM149.574 24.8v-6.785c0-4.356 2.587-6.6 6.442-6.6s6.442 2.218 6.442 6.6v6.785h-2.851v-6.785c0-2.64-1.426-3.96-3.59-3.96s-3.59 1.32-3.59 3.96v6.785h-2.851z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#173d33",
    style: {
      fill: "var(--color2, #173d33)"
    },
    d: "M17.064 21.447c-0.052-0.123-4.312-8.448-4.382-8.563-0.147-0.348-0.365-0.661-0.641-0.922s-0.603-0.462-0.961-0.593-0.74-0.186-1.121-0.165c-0.381 0.022-0.754 0.121-1.095 0.291s-0.642 0.408-0.886 0.698c-0.244 0.29-0.424 0.627-0.529 0.988s-0.135 0.741-0.085 1.115c0.050 0.373 0.177 0.733 0.374 1.055 0.052 0.123 4.13 8.092 4.2 8.206 0.052 0.123 0.113 0.242 0.183 0.357 0.147 0.348 0.365 0.661 0.641 0.922s0.603 0.462 0.961 0.593 0.74 0.186 1.121 0.165c0.381-0.022 0.754-0.121 1.095-0.291s0.642-0.408 0.886-0.698 0.424-0.627 0.53-0.988c0.106-0.362 0.135-0.741 0.085-1.115s-0.177-0.733-0.374-1.055z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97d28b",
    style: {
      fill: "var(--color1, #97d28b)"
    },
    d: "M12.143 15.814c0.261-0.274 0.462-0.599 0.591-0.954s0.181-0.731 0.155-1.107c-0.026-0.376-0.13-0.742-0.306-1.076s-0.42-0.629-0.716-0.866c-0.297-0.237-0.64-0.411-1.007-0.512s-0.753-0.125-1.131-0.072c-0.378 0.053-0.741 0.182-1.066 0.379s-0.606 0.458-0.824 0.767c-0.092 0.096-7.010 8.504-7.086 8.612-0.261 0.274-0.462 0.599-0.591 0.954s-0.181 0.731-0.155 1.107c0.026 0.376 0.13 0.742 0.306 1.076s0.42 0.629 0.716 0.866c0.297 0.237 0.639 0.411 1.007 0.512s0.753 0.125 1.131 0.072c0.378-0.053 0.741-0.182 1.066-0.379s0.606-0.458 0.824-0.767c0.092-0.096 7.010-8.504 7.086-8.612z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97d28b",
    style: {
      fill: "var(--color1, #97d28b)"
    },
    d: "M24.048 15.813c0.261-0.275 0.462-0.599 0.591-0.954s0.181-0.731 0.155-1.107c-0.026-0.376-0.13-0.742-0.306-1.076s-0.42-0.629-0.716-0.866c-0.297-0.237-0.64-0.411-1.007-0.512s-0.753-0.125-1.131-0.072c-0.378 0.053-0.741 0.182-1.066 0.379s-0.606 0.458-0.824 0.767c-0.092 0.096-7.010 8.504-7.086 8.612-0.261 0.275-0.462 0.599-0.59 0.954s-0.181 0.731-0.155 1.107c0.026 0.376 0.13 0.742 0.306 1.076s0.42 0.629 0.716 0.866c0.297 0.237 0.64 0.411 1.007 0.512s0.753 0.125 1.131 0.072c0.378-0.053 0.741-0.182 1.066-0.379s0.606-0.458 0.824-0.767c0.092-0.096 7.010-8.504 7.086-8.612z"
  })), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-btn-arrow-down",
    viewBox: "0 0 30 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.867 16c0 8.247-6.686 14.933-14.933 14.933S.001 24.247.001 16 6.687 1.067 14.934 1.067 29.867 7.753 29.867 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.778,
    d: "m19.789 17.728-4.856 4.316-4.856-4.316M14.932 9.956v11.968"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.2571f54d15455db666be81d4fb947260.svg";
export { ForwardRef as ReactComponent };